// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { getCompletedReservesReport } from '../../../redux/reports/completedReservesReport/actions';
// Constants
import { completedReservesReportColumns } from '../../../enums/columns/completedReservesReport';
// Components
import Table from '../../../components/table';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
//utils
import submitForm from '../../../utils/submitForm';
import ENUMS from '../../../enums';
import { requester } from '../../../utils';

const pageSize = 10;

function CompletedReservesReport() {
  const formRefrence = useRef();
  const ref = useRef();
  const dispatch = useDispatch();
  const state = useSelector(state => state.completedReservesReportReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    sortType: 'desc',
    sortBy: 'date',
    sortQuery: '',
    filterQuery: '',
  });
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    cafeNamePart: '',
    trackingNumberPart: '',
    fromDate: '',
    toDate: '',
  });

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${sort.sortQuery || 'date-desc'}`;
      if (sort.filterQuery) {
        query += '&' + sort.filterQuery;
      }
      return query;
    }
  };

  const onPageChanged = pageNumber => {
    setCurrentPage(pageNumber);
    const query = buildSearchQuery(pageNumber, pageSize);
    dispatch(getCompletedReservesReport(query));
  };

  const sortTable = columnName => {
    const sortType = sort.sortType === 'asc' ? 'desc' : 'asc';
    setSort({ ...sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(currentPage, pageSize);
    dispatch(getCompletedReservesReport(searchQuery));
  };

  const applyFilters = event => {
    event.preventDefault();
    if (!error) {
      const queryString = submitForm(event);
      setSort({ ...sort, filterQuery: queryString });
    }
  };

  const resetForm = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFormData({
      cafeNamePart: '',
      trackingNumberPart: '',
      fromDate: '',
      toDate: '',
    });
    setSort({ ...sort, filterQuery: '' });
    setError('');
  };

  const handleEndDataChange = val => {
    setFormData({ ...formData, toDate: val });
    if (formData.fromDate > val) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    } else {
      setError('');
    }
  };

  const handleStartDateChange = val => {
    setFormData({ ...formData, fromDate: val });
    if (val <= formData.toDate) {
      setError('');
    } else if (val > formData.toDate) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    }
  };

  const exportExcel = async e => {
    e.preventDefault();
    let  query ;
    if (sort.filterQuery !== ""){
       query = `${sort.filterQuery}&sort=${sort.sortBy}-${sort.sortType}`;
    }else {
      query = `sort=${sort.sortBy}-${sort.sortType}`;
    }

    const response = await requester
      .getFileFromAPI({
        route: `v1/reserve/archive/cafes/excel?${query}`,
        contentType: 'application/octet-stream'
      })
    const fileName = response.headers["content-disposition"]
    const file = fileName.replaceAll("attachment; filename=","")
    ref.current.href = URL.createObjectURL(response.data);
    ref.current.download = file;
    ref.current.click();
  };


  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [sort]);

  return (
    <section>
      <div className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-muted py-4'>
          <div className='text-right'>
            {locales('titles.reportsOfFinishedReserves')}
          </div>
        </h3>
        <section className="page-header">
          <div className="form-actions">
            <a style={{ display: 'none' }} href="empty" ref={ref}>
              ref
            </a>
            <button className="btn btn-success" onClick={exportExcel}>
              <i className="fal fa-file-excel mx-1" />
              {locales('labels.excel.output')}
            </button>
          </div>
        </section>
      </div>

      <div id='filter-part'>
        <form
          onReset={event => resetForm(event)}
          onSubmit={event => applyFilters(event)}
          id='form'
          ref={formRefrence}
          className='card card my-4'
        >
          <header className='text-center card-header'>
            <h5 className='font-italic text-muted'>
              {locales('titles.filter')}
            </h5>
          </header>
          <main className='card-body'>
            {error && (
              <div
                style={{ color: 'red', fontSize: '0.8rem', textAlign: 'end' }}
              >
                {error}
              </div>
            )}

            <div className='d-flex row flex-sm-column col-12 flex-md-row px-3 mx-1'>
              <div className='form-group d-flex col-lg-6 col-md-12 col-sm-12'>
                <label className='rsee-form-label col-lg-2 text-right mx-2'>
                  {locales('fields.cafe.name')}
                </label>
                <input
                  name='cafeNamePart'
                  type='text'
                  value={formData.cafeNamePart}
                  onChange={event =>
                    setFormData({
                      ...formData,
                      cafeNamePart: event.target.value,
                    })
                  }
                  className='form-control full-width'
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='cafeNameInput'
                />
              </div>
              <div className='form-group d-flex col-lg-6 col-md-12 col-sm-12'>
                <label className='rsee-form-label col-lg-2 text-right mx-2'>
                  {locales('labels.financial.transaction.reserveNumber')}
                </label>
                <input
                  name='trackingNumberPart'
                  type='text'
                  value={formData.trackingNumberPart}
                  onChange={event =>
                    setFormData({
                      ...formData,
                      trackingNumberPart: event.target.value,
                    })
                  }
                  className='form-control full-width'
                  placeholder={locales(
                    'labels.financial.transaction.reserveNumber',
                  )}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='trackingNumberInput'
                />
              </div>
            </div>

            <div className='d-flex row flex-sm-column col-12 flex-md-row px-3 mx-1'>
              <div className='form-group d-flex col-md-12 col-sm-12 mx-1'>
                <label className='rsee-form-label col-lg-1 text-right'>
                  {locales('labels.reserve.date')}
                </label>
                <div className='d-flex ml-1'>
                  <DatePicker
                    marge={true}
                    placeholder='تاریخ شروع'
                    name='fromDate'
                    className='form-control col-3 col-md-5'
                    value={formData.fromDate}
                    onChange={value => handleStartDateChange(value)}
                  />
                </div>
                <div  className='d-flex col-md-5'>
                  <DatePicker
                    marge={true}
                    placeholder='تاریخ پایان'
                    name='toDate'
                    className='form-control col-3 col-md-5'
                    value={formData.toDate}
                    onChange={v => handleEndDataChange(v)}
                  />
                </div>
              </div>
            </div>

            <div className='col-12 d-flex justify-content-end p-0 my-3'>
              <div style={{ textAlign: 'center' }}>
                <input
                  name='resetButton'
                  type='reset'
                  value={locales('fields.reset')}
                  className='btn btn-danger w-5 mx-2'
                  maxLength='10'
                />
                <button
                  type='submit'
                  id='apply-filter-btn-cafe'
                  className='btn btn-success w-5 mx-2'
                  name='filter'
                >
                  {locales('fields.applyFilters')}
                </button>
              </div>
            </div>
          </main>
        </form>
      </div>

      <div className='bg-white p-2'>
        <div className='table-responsive-lg'>
          <Table
            columns={completedReservesReportColumns}
            dataSource={state.completedReservesReport}
            loading={state.getCompletedReservesReportLoading}
            sort={{ type: sort.sortType, action: sortTable }}
            pagination={{
              currentPage: currentPage,
              pageSize: pageSize,
              totalCount: state.completedReserveReport.totalRecords,
              onPageChange: onPageChanged,
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default CompletedReservesReport;
